export default {
	importParcels(state) {
		return state.importParcels;
	},
	logistics(state) {
		return state.logistics;
	},
	boxTypes(state) {
		return state.boxTypes;
	},	
	units(state) {
		return state.units;
	},
	customers(state) {
		return state.customers;
	},
	barcodes(state) {
		return state.barcodes;
	},	
	lotParcel(state){
		return state.lotParcel;

	}
};
